import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { Grid } from '@mui/material';
import { compose } from 'redux';
import OfferPartnerQuestionsListItemComponent from './OfferPartnerQuestionListItemComponent';

const OfferPartnerListQuestionsListComponent = ({ partnerQuestions }) => {
  return partnerQuestions?.length > 0 ? (
    <Grid container mt={2}>
      {partnerQuestions.map((item, idx) => {
        return (
          <Grid item xs={12} key={idx}>
            <OfferPartnerQuestionsListItemComponent currentQuestion={item} editQuestionnaireMode={false} />
            <br />
          </Grid>
        );
      })}
    </Grid>
  ) : (
    <></>
  );
};
OfferPartnerListQuestionsListComponent.propTypes = {
  partnerQuestions: PropTypes.array.isRequired
};

export default compose(withTranslation())(OfferPartnerListQuestionsListComponent);
